export default {
  outbound: 'Heen',
  inbound: 'Terug',
  hide: 'Verbergen',
  details: 'Details',
}
